exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=\"text\"] {\n  background: none !important;\n}\n.dialog_size{\n  height: 300px;\n}\n", ""]);

// exports
